module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Acknowledgments#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Abbreviations#fm-3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Issues in Interpreting and Preaching Old Testament Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-1"
    }
  }, [_vm._v("Difficulties in Preaching Old Testament Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-1"
    }
  }, [_c('em', [_vm._v("The Issue of Continuity and Discontinuity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-2"
    }
  }, [_c('em', [_vm._v("The Issue of Law and Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-3"
    }
  }, [_c('em', [_vm._v("Proposed Solution: A Threefold Distinction between Old Testament Laws")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-4"
    }
  }, [_c('em', [_vm._v("A Better Solution: Torah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-5"
    }
  }, [_c('em', [_vm._v("Continuity in the Midst of Discontinuity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-2"
    }
  }, [_vm._v("Interpreting Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-6"
    }
  }, [_c('em', [_vm._v("Literary Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-7"
    }
  }, [_c('em', [_vm._v("Historical Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-8"
    }
  }, [_c('em', [_vm._v("Theocentric Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-9"
    }
  }, [_c('em', [_vm._v("Christocentric Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-3"
    }
  }, [_vm._v("Ten Steps in Preaching Christ from Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-10"
    }
  }, [_c('em', [_vm._v("Select the preaching text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-11"
    }
  }, [_c('em', [_vm._v("Read the text in its literary context")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-12"
    }
  }, [_c('em', [_vm._v("Outline the structure of the text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-13"
    }
  }, [_c('em', [_vm._v("Interpret the text in its own historical setting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-14"
    }
  }, [_c('em', [_vm._v("Formulate the text’s theme, goal, and need")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-15"
    }
  }, [_c('em', [_vm._v("Understand the message in the contexts of canon and redemptive history")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-16"
    }
  }, [_c('em', [_vm._v("Formulate the sermon theme, goal, and need addressed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-17"
    }
  }, [_c('em', [_vm._v("Select a suitable sermon form")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-18"
    }
  }, [_c('em', [_vm._v("Prepare the sermon outline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-19"
    }
  }, [_c('em', [_vm._v("Write the sermon in oral style")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Burnt Offering (Leviticus 1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Symbolism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Ordination of Priests (Leviticus 8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Narrative Plotline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" Accepts the First Offerings (Leviticus 9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Narrative Plotline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" Judgment on Unholy Offerings (Leviticus 10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Narrative Plotline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Holy, for the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" Is Holy (Leviticus 11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Trace the Longitudinal Theme")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Way of Contrast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec2-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Form")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Day of Atonement (Leviticus 16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Narrative Plotline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec2-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Shall Love Your Neighbor as Yourself (Leviticus 19:1–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec2-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec2-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec2-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Analogy and Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("You Shall Love Aliens and Enemies as Yourself (Leviticus 19:1–2, 19–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("The Sabbatical Year (Leviticus 25:1–7, 18–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-58",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Redemptive-Historical Progression Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec2-60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Analogy Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("The Year of Jubilee (Leviticus 25:8–17, 23–55)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text and Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec2-61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Repetition of Key Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec2-62",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rhetorical Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec2-63",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Textual Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Preach Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec2-64",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Typology Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec2-65",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Longitudinal Themes Supported by New Testament References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Theme, Goal, and Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermon Exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix01#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Appendix01#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ten Steps from Text to Sermon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Appendix02#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("An Expository Sermon Model")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Appendix03#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Three Sermons "), _c('em', [_vm._v("by Ryan Faber")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Appendix03#sec-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“And the Glory of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" Appeared!”: A Sermon on Leviticus 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Appendix03#sec-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Be Holy!”: A Sermon on Leviticus 11:44–47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Appendix03#sec-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Land Must Rest”: A Sermon on Leviticus 25:1–7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Appendix04#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("“Jubilee Justice”: A Sermon on Leviticus 25 "), _c('em', [_vm._v("by Sidney Greidanus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SELECT BIBLIOGRAPHY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0